import React, { useEffect, useState } from 'react';
import TrainingService from '../../Service/TrainingService';

const TrainingLocation = ({ training }) => {
    const [editMode, setEditMode] = useState(false);
    const [location, setLocation] = useState('');
    const token = sessionStorage.getItem('token');

    // Set the initial location value
    useEffect(() => {
        if (training.quality) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = training.quality;  // If training.qualite is in HTML, convert it to plain text
            setLocation(tempDiv.innerText);  // Use plain text for editing
        } else {
            // Default placeholder if no location is provided
            setLocation('Valenciennes au 17 rue Jules Delsart');
        }
    }, [training.quality]);

    const handleEditClick = () => {
        setEditMode(true);
    };

    const handleLocationChange = (event) => {
        setLocation(event.target.value); // Update location when user types
    };

    const handleSaveClick = async () => {
        // Save the modified location back to the training object
        training.quality = location;

        try {
            let response;
            if (training.modif) {
                response = await TrainingService.putModifTraining(training);
            } else {
                response = await TrainingService.postModifTraining(training);
            }
            window.location.reload();
            console.log(response);
        } catch (error) {
            console.log("Error: " + error);
        }
        setEditMode(false); // Exit edit mode after saving
    };

    return (
        <div className="section-content">
            {editMode ? (
                <div>
                    {/* Edit mode: textarea for changing the location */}
                    <label>Lieu de la formation :</label>
                    <textarea
                        value={location}
                        onChange={handleLocationChange}
                        rows={3}
                        style={{ width: '100%' }}
                    />
                </div>
            ) : (
                // Display mode: Show the location or placeholder text
                <p>
                    Cette formation est dispensée dans nos locaux suivants : <br /><br />
                    {location}
                </p>
            )}
            {editMode ? (
                <button
                    className="inscription-button modif_button"
                    onClick={handleSaveClick}
                    style={{ right: 0 }}
                >
                    Enregistrer
                </button>
            ) : (
                token === '' && (
                    <button
                        className="inscription-button modif_button"
                        onClick={handleEditClick}
                        style={{ marginLeft: '10px' }}
                    >
                        Modifier
                    </button>
                )
            )}
        </div>
    );
};

export default TrainingLocation;